export function keepRoomsOnReconnect(socket, join, onReconnect) {
   let hasConnected = false

   socket.on("connect", () => {
      join()
      if (hasConnected) onReconnect?.()
      hasConnected = true
   })

   // socket.io-client 4.1.2 does not auto-reconnect after a server-side disconnect
   socket.on("disconnect", (reason) => {
      if (reason === "io server disconnect") socket.connect()
   })
}
